export type FabricType = 'woven' | 'knit';

export type StageType =
  | 'knitting'      // 織工 (KNIT KG)
  | 'dyeing'        // 染工
  | 'chemical'      // 藥劑加工
  | 'brushing'      // 刷毛/磨毛
  | 'inspection'    // 驗貨 (YD)
  | 'printing'      // 印花 (YD)
  | 'calendering'   // 壓光/壓花 (YD)
  | 'lamination';   // 貼合 (YD)

/** KNIT 中屬於 KG 計價的工段 */
export const KNIT_KG_STAGES: StageType[] = ['knitting', 'dyeing', 'chemical', 'brushing'];

export const STAGE_LABELS: Record<StageType, string> = {
  knitting: '織工',
  dyeing: '染工',
  chemical: '藥劑加工',
  brushing: '刷毛/磨毛',
  inspection: '驗貨',
  printing: '印花',
  calendering: '壓光/壓花',
  lamination: '貼合',
};

export interface ChainStage {
  id: string;
  type: StageType;
  cost: number;
  lossRate: number;      // %
  inspectionFee: number;
  chemicalProduct?: string;  // 藥劑產品名稱/代號
}

export interface YarnEntry {
  id: string;
  code: string;
  price: number;
  ratio: number; // %
}

export interface FabricConfig {
  type: FabricType;
  fabricCode: string;
  // WOVEN 基礎
  rawFabricCode: string;  // 胚布編號
  basePrice: number;
  baseLossRate: number;   // %
  processingFee: number;
  // KNIT 基礎
  fabricWeight: number;   // 碼重 g/yd
  yarns: YarnEntry[];
  // 動態工段鏈
  stages: ChainStage[];
}

// ===== 計算結果 =====
export interface StageResult {
  id: string;
  name: string;
  stageCost: number;
  lossAmount: number;
  inspectionFee: number;
  subtotal: number;
  unit: 'KG' | 'YD';
}

export interface ConversionResult {
  costPerKg: number;
  costPerYd: number;
  subtotal: number;
}

export interface FabricResult {
  stages: StageResult[];
  conversion?: ConversionResult;
  totalCostYd: number;
}

export interface FullResult {
  fabric1: FabricResult;
  fabric2?: FabricResult;
  fabric3?: FabricResult;
  lam1Cost: number;                // 第一次貼合後成本
  postLam1Results: StageResult[];  // 第一次貼合後工段結果（4層：雙層→三層之間）
  afterPostLam1Cost: number;       // postLam1 工段後的成本（進入第二次貼合前）
  lam2Cost: number;                // 第二次貼合後成本（4層模式）
  laminatedCost: number;           // 最終貼合成本（後續工段前）
  postLamResults: StageResult[];   // 最終貼合後工段計算結果
  combinedCost: number;           // 最終成本（含後續工段）
  sellingPrice: number;
  roundedPrice: number;
}
